<template>
  <div class="backing-service-container">
    <h5>Services</h5>
    <div class="row" style="padding: 0 8px;">
      <div class="card col-md-3 backing-service" v-for="(service, key) in services">
        <div class="card-header">
          <p>{{service.name}}</p>
        </div>
        <div class="card-content get-centered">
          <img :src="whichIcon(service.state)" />
        </div>
        <div class="card-footer get-centered">
          <a href="#" v-on:click="refreshService(key)">Update Now</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import {notifySuccess, notifyError} from 'src/utilities/utils'
  import {OK} from 'http-status-codes'

  export default {
    computed: {
      ...mapGetters({
        services: 'apiHealth/services'
      })
    },
    methods: {
      async refreshService(serviceKey) {
        const service = this.services[serviceKey]
        const response = await this.$store.dispatch('apiHealth/' + serviceKey)
        if (OK === response.status) {
          notifySuccess(this, service.name + ' is up. ')
          return
        }

        notifyError(this, service.name + ' is down.')
      },
      whichIcon(state) {
        let img;
        switch(state) {
          case 'error':
            img = 'active-error.png'
            break;
          case 'down':
            img = 'active-false.png'
            break;
          case 'up':
            img = 'active-true.png'
            break;
          default:
            img = 'loading-2.gif'
        }
        return `static/img/${img}`
      }
    },
    beforeMount() {
      this.$store.dispatch('apiHealth/fetchAll')
    }
  }
</script>
<style scoped>
  .backing-service-container {
    padding-bottom: 12px;
  }
  .backing-service {
    margin: 9px;
  }
  .backing-service.col-md-3 {
    max-width: 23.1%;
  }
  .card-footer.nc-icon {
    margin-top: 5px;
  }
  .get-centered {
    text-align: center;
  }
</style>
